module.exports = __webpack_public_path__ + "static/img/wcm_2line_cobrand_rgb.452835f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wcm_2line_cobrand_rgb.png
// module id = Z+ms
// module chunks = 1